import { useEffect, useState } from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';

import './App.css';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Modules from './pages/Modules';
import Profile from './pages/Profile';
import ProtectedRoute from './ProtectedRoute';

import ApplicationForm from './pages/crm/ApplicationForm';
import CustomerDetail from './pages/crm/CustomerDetail';
import Customers from './pages/crm/Customers';
import NewApplication from './pages/crm/NewApplication';
import Verification from './pages/crm/Verification';
import Inspection from './pages/field/Inspection';
import Installation from './pages/field/Installation';

import { getUser } from './auth';
import CustomerMeterDetail from './pages/crm/CustomerMeterDetail';
import CustomerMeterForm from './pages/crm/CustomerMeterForm';
import InspectionForm from './pages/field/InspectionForm';
import InstallationForm from './pages/field/InstallationForm';
import ScheduleInspection from './pages/field/ScheduleInspection';
import ScheduleInstallation from './pages/field/ScheduleInstallation';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = getUser();
    if (saved) {
      setUser(saved);
    }
    setLoading(false);
  }, []);

  if (loading) return null;

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login user={user} setUser={setUser} />} />

        <Route
          path="/modules"
          element={
            <ProtectedRoute user={user}>
              <Modules />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute user={user}>
              <Layout user={user} setUser={setUser}>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/:module/*"
          element={
            <ProtectedRoute user={user}>
              <Layout user={user} setUser={setUser} />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/:id" element={<CustomerDetail />} />
          <Route path="for-verification/:id" element={<CustomerMeterDetail />} />
          <Route path="meter-form/:id" element={<CustomerMeterForm />} />
          <Route path="for-inspection/:id" element={<CustomerDetail />} />
          <Route path="for-installation/:id" element={<CustomerDetail />} />
          <Route path="new-application" element={<NewApplication />} />
          <Route path="verification/:status" element={<Verification />} />
          <Route path="inspection/:status" element={<Inspection />} />
          <Route path="installation/:status" element={<Installation />} />
          <Route path="application/:id?" element={<ApplicationForm />} />
          <Route path="schedule-inspection/:id" element={<ScheduleInspection />} />
          <Route path="schedule-installation/:id" element={<ScheduleInstallation />} />
          <Route path="inspection-form/:id" element={<InspectionForm />} />
          <Route path="installation-form/:id" element={<InstallationForm />} />

        </Route>

        <Route path="/" element={<Navigate to="/modules" />} />
        <Route
          path="*"
          element={<Navigate to={user ? '/modules' : '/login'} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
